<div class="testumgebungen" data-testid="umgebungen-karte">
  @switch (ladestatus()) {
    @case ('laedt') {
      <p class="testumgebungen__hinweis" role="status" aria-live="polite" data-testid="umgebungen-laedt">
        {{ 'projectForm.umgebungen.laedt' | translate }}
      </p>
    }
    @case ('fehler') {
      <div class="testumgebungen__ladefehler" role="alert" data-testid="umgebungen-ladefehler">
        <span>{{ 'projectForm.umgebungen.ladefehler' | translate }}</span>
        <button mat-stroked-button type="button" data-testid="umgebungen-erneut" (click)="laden()">
          {{ 'projectForm.umgebungen.erneutVersuchen' | translate }}
        </button>
      </div>
    }
    @default {
      @if (zeilen().length) {
        <div class="testumgebungen__tabelle">
          <div class="testumgebungen__raster testumgebungen__kopfzeile" data-testid="umgebungen-kopfzeile">
            <div>{{ 'projectForm.umgebungen.spalten.name' | translate }}</div>
            <div>{{ 'projectForm.umgebungen.spalten.url' | translate }}</div>
            <div>{{ 'projectForm.umgebungen.spalten.zugang' | translate }}</div>
            <div>{{ 'projectForm.umgebungen.spalten.testdaten' | translate }}</div>
            <div></div>
          </div>
          @for (u of zeilen(); track u.id) {
            @let auf = offen() === u.id;
            <div class="testumgebungen__zeile" [class.testumgebungen__zeile--offen]="auf" data-testid="umgebung-zeile">
              <div
                class="testumgebungen__raster testumgebungen__zeilenkopf"
                role="button"
                tabindex="0"
                data-testid="umgebung-kopf"
                [id]="kopfId(u.id)"
                [attr.aria-expanded]="auf"
                [attr.aria-controls]="auf ? formularId(u.id) : null"
                (click)="umschalten(u.id)"
                (keydown.enter)="perTaste($event, u.id)"
                (keydown.space)="perTaste($event, u.id)"
              >
                <span
                  class="testumgebungen__zelle testumgebungen__name"
                  data-testid="umgebung-name-zelle"
                  [title]="u.name"
                >
                  {{ u.name || ('projectForm.umgebungen.neueUmgebung' | translate) }}
                </span>
                <code
                  class="testumgebungen__zelle testumgebungen__url"
                  [class.testumgebungen__zelle--leer]="!u.url"
                  data-testid="umgebung-url-zelle"
                  [title]="u.url ?? ''"
                >
                  {{ u.url || ('projectForm.umgebungen.keineUrl' | translate) }}
                </code>
                <span
                  class="testumgebungen__zelle testumgebungen__zugang"
                  [class.testumgebungen__zugang--fehlt]="!u.passwordSet"
                  data-testid="umgebung-zugang-zelle"
                >
                  @if (!u.passwordSet) {
                    {{ 'projectForm.umgebungen.zugangFehlt' | translate }}
                  } @else if (u.username) {
                    {{ 'projectForm.umgebungen.zugangBenutzer' | translate: { benutzer: u.username } }}
                  } @else {
                    {{ 'projectForm.umgebungen.zugangHinterlegt' | translate }}
                  }
                </span>
                <span
                  class="testumgebungen__zelle"
                  [class.testumgebungen__zelle--leer]="!u.defaultTdbId"
                  data-testid="umgebung-tdb-zelle"
                >
                  @if (u.defaultTdbId) {
                    {{ blattName(u.defaultTdbId) ?? ('projectForm.umgebungen.gespeichertesBlatt' | translate) }}
                  } @else {
                    —
                  }
                </span>
                <span class="testumgebungen__aktion" data-testid="umgebung-aktion-zelle">
                  {{ (auf ? 'projectForm.umgebungen.schliessen' : 'projectForm.umgebungen.bearbeiten') | translate }}
                  <mat-icon
                    class="testumgebungen__chevron"
                    [class.testumgebungen__chevron--offen]="auf"
                    aria-hidden="true"
                    fontIcon="chevron_right"
                  />
                </span>
              </div>

              @if (auf) {
                @let fehlerJetzt = fehler();
                <div class="testumgebungen__formular" data-testid="umgebung-formular" [id]="formularId(u.id)">
                  <div class="testumgebungen__feld">
                    <label class="testumgebungen__label" [for]="feldId(u.id, 'name')">
                      {{ 'projectForm.umgebungen.felder.name' | translate }}
                      <span class="testumgebungen__pflicht" aria-hidden="true">*</span>
                    </label>
                    <input
                      #nameFeld
                      type="text"
                      class="testumgebungen__eingabe"
                      data-testid="umgebung-name"
                      required
                      [id]="feldId(u.id, 'name')"
                      [class.testumgebungen__eingabe--ungueltig]="!!fehlerJetzt.name"
                      [value]="entwurf().name"
                      [placeholder]="'projectForm.umgebungen.felder.namePlatzhalter' | translate"
                      [attr.maxlength]="fieldLengths.ENVIRONMENT_MAX"
                      [attr.aria-invalid]="fehlerJetzt.name ? true : null"
                      [attr.aria-describedby]="fehlerJetzt.name ? feldId(u.id, 'name-fehler') : null"
                      [disabled]="nurLesen()"
                      (input)="aendern('name', nameFeld.value)"
                      (keydown.enter)="perEingabetaste($event)"
                    />
                    @if (fehlerJetzt.name; as schluessel) {
                      <div
                        class="testumgebungen__fehler"
                        data-testid="umgebung-name-fehler"
                        [id]="feldId(u.id, 'name-fehler')"
                      >
                        {{ 'projectForm.umgebungen.fehler.' + schluessel | translate }}
                      </div>
                    }
                  </div>

                  <div class="testumgebungen__feld">
                    <label class="testumgebungen__label" [for]="feldId(u.id, 'url')">
                      {{ 'projectForm.umgebungen.felder.url' | translate }}
                    </label>
                    <input
                      #urlFeld
                      type="text"
                      class="testumgebungen__eingabe testumgebungen__eingabe--mono"
                      data-testid="umgebung-url"
                      [id]="feldId(u.id, 'url')"
                      [class.testumgebungen__eingabe--ungueltig]="!!fehlerJetzt.url"
                      [value]="entwurf().url"
                      [placeholder]="'projectForm.umgebungen.felder.urlPlatzhalter' | translate"
                      [attr.maxlength]="fieldLengths.URL_MAX"
                      [attr.aria-invalid]="fehlerJetzt.url ? true : null"
                      [attr.aria-describedby]="fehlerJetzt.url ? feldId(u.id, 'url-fehler') : null"
                      [disabled]="nurLesen()"
                      (input)="aendern('url', urlFeld.value)"
                      (keydown.enter)="perEingabetaste($event)"
                    />
                    @if (fehlerJetzt.url; as schluessel) {
                      <div
                        class="testumgebungen__fehler"
                        data-testid="umgebung-url-fehler"
                        [id]="feldId(u.id, 'url-fehler')"
                      >
                        {{ 'projectForm.umgebungen.fehler.' + schluessel | translate }}
                      </div>
                    }
                  </div>

                  <div class="testumgebungen__feld">
                    <label class="testumgebungen__label" [for]="feldId(u.id, 'benutzer')">
                      {{ 'projectForm.umgebungen.felder.benutzer' | translate }}
                    </label>
                    <input
                      #benutzerFeld
                      type="text"
                      class="testumgebungen__eingabe"
                      data-testid="umgebung-benutzer"
                      autocomplete="off"
                      [id]="feldId(u.id, 'benutzer')"
                      [value]="entwurf().username"
                      [placeholder]="'projectForm.umgebungen.felder.benutzerPlatzhalter' | translate"
                      [attr.maxlength]="fieldLengths.ENVIRONMENT_USERNAME_MAX"
                      [disabled]="nurLesen()"
                      (input)="aendern('username', benutzerFeld.value)"
                      (keydown.enter)="perEingabetaste($event)"
                    />
                  </div>

                  <div class="testumgebungen__feld">
                    @if (nurLesen()) {
                      <span class="testumgebungen__label" [id]="feldId(u.id, 'passwort-label')">
                        {{ 'projectForm.umgebungen.felder.passwort' | translate }}
                      </span>
                      <div
                        class="testumgebungen__eingabe testumgebungen__eingabe--lesend"
                        data-testid="umgebung-passwort-status"
                        [attr.aria-labelledby]="feldId(u.id, 'passwort-label')"
                      >
                        {{
                          (u.passwordSet
                            ? 'projectForm.umgebungen.felder.passwortHinterlegt'
                            : 'projectForm.umgebungen.felder.passwortFehlt'
                          ) | translate
                        }}
                      </div>
                    } @else {
                      <label class="testumgebungen__label" [for]="feldId(u.id, 'passwort')">
                        {{ 'projectForm.umgebungen.felder.passwort' | translate }}
                      </label>
                      <div class="testumgebungen__passwort">
                        <input
                          #passwortFeld
                          type="password"
                          class="testumgebungen__eingabe"
                          data-testid="umgebung-passwort"
                          autocomplete="new-password"
                          [id]="feldId(u.id, 'passwort')"
                          [value]="entwurf().password"
                          [placeholder]="
                            (passwortHinterlegt()
                              ? 'projectForm.umgebungen.felder.passwortHinterlegtPlatzhalter'
                              : 'projectForm.umgebungen.felder.passwortPlatzhalter'
                            ) | translate
                          "
                          [attr.maxlength]="fieldLengths.ENVIRONMENT_SECRET_MAX"
                          [attr.aria-describedby]="feldId(u.id, 'passwort-hinweis')"
                          (input)="aendern('password', passwortFeld.value)"
                          (keydown.enter)="perEingabetaste($event)"
                        />
                        @if (passwortHinterlegt()) {
                          <button
                            type="button"
                            class="testumgebungen__link"
                            data-testid="umgebung-passwort-entfernen"
                            [attr.aria-label]="'projectForm.umgebungen.felder.passwortEntfernenAria' | translate"
                            [disabled]="speichert()"
                            (click)="passwortEntfernen()"
                          >
                            {{ 'projectForm.umgebungen.felder.passwortEntfernen' | translate }}
                          </button>
                        }
                      </div>
                      <div
                        class="testumgebungen__feldhinweis"
                        data-testid="umgebung-passwort-hinweis"
                        [id]="feldId(u.id, 'passwort-hinweis')"
                      >
                        {{ 'projectForm.umgebungen.felder.passwortHinweis' | translate }}
                      </div>
                    }
                  </div>

                  <div class="testumgebungen__feld">
                    <label class="testumgebungen__label" [for]="feldId(u.id, 'testdaten')">
                      {{ 'projectForm.umgebungen.felder.testdaten' | translate }}
                    </label>
                    <select
                      #blattAuswahl
                      class="testumgebungen__eingabe"
                      data-testid="umgebung-tdb"
                      [id]="feldId(u.id, 'testdaten')"
                      [class.testumgebungen__eingabe--ungueltig]="!!fehlerJetzt.defaultTdbId"
                      [attr.aria-invalid]="fehlerJetzt.defaultTdbId ? true : null"
                      [attr.aria-describedby]="
                        fehlerJetzt.defaultTdbId ? feldId(u.id, 'testdaten-fehler') : feldId(u.id, 'testdaten-hinweis')
                      "
                      [disabled]="nurLesen() || blaetterStatus() === 'laedt'"
                      (change)="blattWaehlen(blattAuswahl.value)"
                    >
                      <option value="" [selected]="!entwurf().defaultTdbId">
                        {{ 'projectForm.umgebungen.felder.keine' | translate }}
                      </option>
                      @for (option of blattOptionen(); track option.id) {
                        <option [value]="option.id" [selected]="entwurf().defaultTdbId === option.id">
                          {{ option.label ?? ('projectForm.umgebungen.gespeichertesBlatt' | translate) }}
                        </option>
                      }
                    </select>
                    @if (fehlerJetzt.defaultTdbId; as schluessel) {
                      <div
                        class="testumgebungen__fehler"
                        data-testid="umgebung-tdb-fehler"
                        [id]="feldId(u.id, 'testdaten-fehler')"
                      >
                        {{ 'projectForm.umgebungen.fehler.' + schluessel | translate }}
                      </div>
                    }
                    @if (blaetterStatus() === 'fehler') {
                      <div class="testumgebungen__feldhinweis" data-testid="umgebung-tdb-ladefehler">
                        {{ 'projectForm.umgebungen.felder.testdatenLadefehler' | translate }}
                      </div>
                    }
                    <div
                      class="testumgebungen__feldhinweis"
                      data-testid="umgebung-tdb-hinweis"
                      [id]="feldId(u.id, 'testdaten-hinweis')"
                    >
                      {{ 'projectForm.umgebungen.felder.testdatenHinweis' | translate }}
                    </div>
                  </div>

                  @if (!nurLesen()) {
                    <div class="testumgebungen__fuss">
                      @if (u.id !== neu) {
                        <button
                          type="button"
                          class="testumgebungen__entfernen"
                          data-testid="umgebung-entfernen"
                          [disabled]="speichert()"
                          (click)="entfernenFragen(u)"
                        >
                          <mat-icon class="testumgebungen__entfernen-icon" aria-hidden="true" fontIcon="delete" />
                          {{ 'projectForm.umgebungen.entfernen' | translate }}
                        </button>
                      }
                      <span class="testumgebungen__abstand"></span>
                      <button
                        mat-stroked-button
                        type="button"
                        data-testid="umgebung-abbrechen"
                        [disabled]="speichert()"
                        (click)="abbrechen()"
                      >
                        {{ 'projectForm.umgebungen.abbrechen' | translate }}
                      </button>
                      <button
                        mat-flat-button
                        color="primary"
                        type="button"
                        data-testid="umgebung-speichern"
                        [disabled]="speichernGesperrt()"
                        (click)="speichern()"
                      >
                        {{ 'projectForm.umgebungen.speichern' | translate }}
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <p class="testumgebungen__hinweis" data-testid="umgebungen-leer">
          {{ 'projectForm.umgebungen.leer' | translate }}
        </p>
      }
      @if (!nurLesen()) {
        <button
          type="button"
          class="testumgebungen__hinzufuegen"
          data-testid="umgebung-hinzufuegen"
          [disabled]="hinzufuegenGesperrt()"
          (click)="hinzufuegen()"
        >
          {{ 'projectForm.umgebungen.hinzufuegen' | translate }}
        </button>
      }
    }
  }
</div>

<lib-modal
  #entfernenModal
  [visible]="!!entfernenZiel()"
  [title]="'projectForm.umgebungen.dialog.titel' | translate"
  [contentTemplate]="entfernenInhalt"
  [showButtons]="false"
  [showClose]="false"
  (visibleChange)="beimSchliessenDurchModal($event)"
></lib-modal>

<ng-template #entfernenInhalt>
  <div class="testumgebungen__dialog" data-testid="umgebung-entfernen-dialog">
    <p class="testumgebungen__dialog-text" data-testid="umgebung-entfernen-text">
      {{ 'projectForm.umgebungen.dialog.text' | translate: { name: entfernenZiel()?.name } }}
    </p>
    <div class="testumgebungen__dialog-fuss">
      <button
        mat-stroked-button
        type="button"
        data-testid="umgebung-entfernen-abbrechen"
        [disabled]="entfernenLaeuft()"
        (click)="entfernenAbbrechen()"
      >
        {{ 'projectForm.umgebungen.dialog.abbrechen' | translate }}
      </button>
      <button
        mat-flat-button
        color="warn"
        type="button"
        data-testid="umgebung-entfernen-bestaetigen"
        [disabled]="entfernenLaeuft()"
        (click)="entfernenBestaetigen()"
      >
        {{ 'projectForm.umgebungen.dialog.entfernen' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<lib-modal
  [visible]="!!verwerfenAktion()"
  [title]="'projectForm.deactivateConfirm.title' | translate"
  [contentTemplate]="verwerfenInhalt"
  [showButtons]="false"
  [showClose]="false"
  (visibleChange)="beimSchliessenDerVerwerfenFrage($event)"
></lib-modal>

<ng-template #verwerfenInhalt>
  <div class="testumgebungen__dialog" data-testid="umgebung-verwerfen-dialog">
    <p class="testumgebungen__dialog-text" data-testid="umgebung-verwerfen-text">
      {{ 'projectForm.deactivateConfirm.message' | translate }}
    </p>
    <div class="testumgebungen__dialog-fuss">
      <button
        mat-stroked-button
        type="button"
        data-testid="umgebung-verwerfen-abbrechen"
        (click)="verwerfenAbbrechen()"
      >
        {{ 'projectForm.deactivateConfirm.cancel' | translate }}
      </button>
      <button
        mat-flat-button
        color="warn"
        type="button"
        data-testid="umgebung-verwerfen-bestaetigen"
        (click)="verwerfenBestaetigen()"
      >
        {{ 'projectForm.deactivateConfirm.confirm' | translate }}
      </button>
    </div>
  </div>
</ng-template>
